const modes = {
  Blur: 'blur',
  Delete: 'delete',
  Reorder: 'reorder',
};
const defaultMode = modes.Blur;

const initialEditState = {
  imageId: null,
  nextImageId: null,
  prevImageId: null,
};

export { defaultMode, initialEditState, modes };
